/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { AnimatePresence, motion } from "framer-motion";
import React, { useState } from "react";
import ReactTooltip from "react-tooltip";
import { customTooltip, notSelect } from "../../styles/general";
import { IExternalUser } from "../../types/ExternalUserTypes";
import ExternalUsersDetails from "../ExternalUsers/ExternalUsersDetail";
import MoreActionsPopOver from "./MoreActionsPopOver";

const TableRow = styled(motion.div)<TableProps>`
  border: 1px solid;
  border-color: ${(props) => (props.check ? "#FB972E" : "#eaeaeabf")};
  background-color: ${(props) =>
    props.check ? "rgb(251, 151, 46, 0.05)" : "#ffffff"};
  align-items: center;
  padding-right: 36px;
  width: 100%;
`;

const GridRow = styled(motion.div)`
  display: flex;
  justify-content: space-between;
  padding: 15px;
  padding-right: 0px;
  align-items: center;
  height: 60px;
`;

const TableTitle = styled.div`
  color: #2f2f2f;
  display: flex;
  font-size: 14px;
  align-items: center;
  /* overflow: hidden; */
  width: 100%;
`;

const Name = styled.span`
  max-width: 10vw;
  margin-left: 10px;
`;

const TextCss = css`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
`;

const TableActionsRow = styled.div`
  color: #2f2f2f;
  display: flex;
  font-size: 14px;
  align-items: center;
  justify-content: space-between;
`;

export const Flex = styled.div`
  display: flex;
  align-items: center;
`;

const TooltipText = styled.span`
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0px;
  color: #ffffff;
`;

const ActionIcon = styled.img<{ isShowing: boolean }>`
  width: 15px;
  height: 15px;
  cursor: pointer;
  ${notSelect}
  transform: rotate(0deg);
  transition: 0.3s;

  ${(props) =>
    props.isShowing &&
    `    transform: rotate(180deg);
    `}
`;

const marginRight15 = css`
  margin-right: 15px;
`;

const marginRight5 = css`
  margin-right: 5px;
`;

interface TableProps {
  show: boolean;
  check: boolean;
}

interface Props {
  row: IExternalUser;
  isShowing: boolean;
  handleShowCard: (id: string) => void;
  updateUsers: () => void;
}

export default function TableRows(props: Props) {
  const { row, isShowing, handleShowCard, updateUsers } = props;
  const [showCard, setShowCard] = useState<string>("");

  return (
    <TableRow
      check={false}
      layout
      show={!showCard.localeCompare(row._id)}
      key={row._id}
      css={css`
        margin-top: 7px;
      `}
    >
      <AnimatePresence>
        <GridRow layout>
          <TableTitle>
            <Name
              css={css`
                ${TextCss}
              `}
            >
              {row.name}
            </Name>
          </TableTitle>

          <TableTitle
            css={css`
              color: #2f2f2f;
              text-align: center;
              ${TextCss}
            `}
          >
            {row.password}
          </TableTitle>
          <TableTitle style={{ justifyContent: "flex-end" }}>
            <TableActionsRow>
              <Flex data-tip data-for="see" style={{ marginRight: "20px" }}>
                <ReactTooltip
                  id="see"
                  place="top"
                  effect="solid"
                  globalEventOff="click"
                  backgroundColor="#333333"
                  css={customTooltip}
                >
                  <TooltipText>See more</TooltipText>
                </ReactTooltip>

                <ActionIcon
                  src={"./icons/arrow-down.svg"}
                  onClick={() => handleShowCard(row._id)}
                  isShowing={isShowing}
                />
              </Flex>
              <MoreActionsPopOver
                updateUsers={updateUsers}
                externalUser={row}
              />
            </TableActionsRow>
          </TableTitle>
        </GridRow>
        {isShowing && <ExternalUsersDetails externalUser={row} />}
      </AnimatePresence>
    </TableRow>
  );
}
